import { PrivacyContent } from "@/components/legal/PrivacyContent";

const PrivacidadePage = () => {
  return (
    <div className="text-gray-900 px-6 py-16 max-w-5xl mx-auto">
      <PrivacyContent withPageTitle />
    </div>
  );
};

export default PrivacidadePage;
